import { render, staticRenderFns } from "./JsonExcel.vue?vue&type=template&id=515f7d6a"
import script from "./JsonExcel.vue?vue&type=script&lang=js"
export * from "./JsonExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports